import Appbar from '../components/appBar';
import Head from 'next/head'; 
import Footer from '../components/footer';
import Grid from '@material-ui/core/Grid'; 
import Contactus from '../components/contactHeader'
import ContactMessage from '../components/contactBody'
import Contactzone from '../components/contactZone'
import WidgetWa from '../components/widgetWa';

export default function Contacto({contactKeys}) {  
  return (
    <> 
      <Head>
        <title>Contacto</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Puede dejarnos todas sus preguntas, comentarios y/o problemas. Nuestro equipo esta disponible para brindarle soluciones efectivas a sus necesidades."/>
        <link rel="canonical" href="https://cidu.com.co/contacto" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head> 
      <Grid> 
        <Appbar/> 
        <Contactus />
        <ContactMessage keys={contactKeys}/>
        <Contactzone/>
        <Footer/>
      </Grid>
      <WidgetWa link={'https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!'} /> 
    </>
  );
};

// pages/index.js
export async function getStaticProps() {
  const contactKeys = await {
    captchaKey: process.env.CAPTCHA_KEY_GOOGLE,
    mapKey: process.env.API_KEY_GOOGLEMAPS,
  }
  return {
    props: {
      contactKeys
    }
  }
}
 